<h3 class="body-400 mb-6">Message contents</h3>

<form autocomplete="off">
  <app-input-with-variable
    class="mb-6"
    [formControl]="subjectControl"
    [variables]="messageVariables"
    (isValid)="isSubjectValid$.next($event)"
    inputType="input"
    label="Subject"
  />

  <app-input-with-variable
    class="mb-6"
    [formControl]="headlineControl"
    [variables]="messageVariables"
    (isValid)="isHeadlineValid$.next($event)"
    hint="Appears at the top of the statement email message body."
    inputType="input"
    label="Headline"
  />

  <app-input-with-variable
    [formControl]="messageControl"
    [variables]="messageVariables"
    (isValid)="isMessageValid$.next($event)"
    hint="The message appears near the top of the statement email body."
    inputType="textarea"
    label="Message"
  />
</form>
